import { render, staticRenderFns } from "./AdvertViews.vue?vue&type=template&id=d15b34b8&scoped=true"
import script from "./AdvertViews.vue?vue&type=script&lang=js"
export * from "./AdvertViews.vue?vue&type=script&lang=js"
import style0 from "./AdvertViews.vue?vue&type=style&index=0&id=d15b34b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15b34b8",
  null
  
)

export default component.exports